import { createEvent } from 'effector'
import { selectEpgProgramModel } from '~/features/epg/programs/select'

// load initial epg info
export const init = createEvent()

// reset widget on epg page left
export const left = createEvent()

// reset widget on sign out
export const reset = createEvent()

// actually select program
export const select = selectEpgProgramModel.select

export const resetProgram = selectEpgProgramModel.deselect

//
// left and reset logic
//

// do nothing
// EPG data does not differs for different users, so,
// there is no need to remove loaded programs on left and/or reset
